const colors = {
    blue: "#12CBC4",
    white: "#FFFFFF",
    gray: "#b2bec3"
  };
  
  export default colors;
  